import { cn } from "../../lib/utils"

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("animate-pulse rounded-4 overflow-hidden", className)} {...props}>
      <div className="bg-neutral-100 w-full h-full" />
    </div>
  )
}

export { Skeleton }
